import axios from 'axios'

export const getAccount = () => {
  return axios.get('setting/account')
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const putAccount = (data) => {
  return axios.put('setting/account', data)
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const putPassword = (data) => {
  return axios.put('setting/password', data)
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getCompanyProfile = () => {
  return axios.get('setting/company')
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const putCompanyProfile = (data) => {
  return axios.put('setting/company', data)
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getDocuments = () => {
  return axios.get('setting/document')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const downloadDocuments = ({type, fileName}) => {
  return axios.get(`file/company/download/doc/stream/${type}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const uploadDocuments = (formData) => {
  return axios.post('file/company/upload/doc', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const getUser = () => {
  return axios.get('setting/user')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const inviteUser = (formData) => {
  return axios.post('setting/invite', formData)
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const uploadPhotoUser = (formData) => {
  return axios.post('file/user/upload/photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const editAccount = (payload) => axios.put('setting/account', payload)
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const getSafDraft = () => axios.get('/service-application-form')
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const saveDraftSaf = (payload) => axios.put('/service-application-form', payload)
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const getConsignee = () => axios.get('/shipper-consignee?type=CONSIGNEE')
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const getShipper = () => axios.get('/shipper-consignee?type=SHIPPER')
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const postConsignee = (payload) => axios.post('/shipper-consignee', payload)
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const editConsignee = (payload) => axios.put(`/shipper-consignee/${payload.id}`, payload.payload)
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const deleteConsignee = (id) => axios.delete(`/shipper-consignee/${id}`)
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const submitSaf = (payload) => axios.post('/service-application-form', payload)
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const getBank = () => axios.get('/service-application-form/bank-list')
  .then(res => res)
  .catch(err => {
    console.log('err', err)
    throw err.response
  })

export const downloadDocumentSaf = () => {
  return axios.get(`/service-application-form/document/download`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'saf.pdf'
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const uploadDocumentSaf = (formData) => {
  return axios.post('/service-application-form/document/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const downloadDocumentSafApproved = () => {
  return axios.get(`/service-application-form/document/download/approved`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'saf.pdf'
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/settings.api.js